import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import Search from './pages/Search';
import Explorer from './pages/Explorer';
import People from './pages/People';
import Stats from './pages/Stats';
import DocumentDetail from './pages/DocumentDetail';
import Timeline from './pages/Timeline';
import Disclaimer from './pages/Disclaimer';
import { trackPageView } from './utils/analytics';

// Component to track page views on route changes
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <PageViewTracker />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Search />} />
          <Route path="/people" element={<People />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/explorer" element={<Explorer />} />
          <Route path="/timeline" element={<Timeline />} />
          <Route path="/document/:slug" element={<DocumentDetail />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
